
import {extend as ol_extent_extend, getCenter as ol_extent_getCenter, createEmpty as ol_extent_createEmpty} from 'ol/extent';
import {distance as ol_coordinate_distance} from 'ol/coordinate';
import {default as ol_collection} from 'ol/Collection';
import {default as ol_feature} from "ol/Feature";
import {default as ol_geometry} from "ol/geom/Geometry";

import isArray from "lodash/isArray";
import each from "lodash/each";
import minBy from "lodash/minBy";

function getExtent(features) {
  let extent;
  if (features instanceof ol_geometry) {
    return features.getExtent();
  } else if (features instanceof ol_feature) {
    return getExtent(features.getGeometry());
  } else if (features instanceof  ol_collection) {
    return getExtent(features.getArray());
  } if (isArray(features) && features.length > 0) {
    if (features[0] instanceof ol_feature) {
      return getExtent(features.map((f) => f.getGeometry()));
    }
    extent = features[0].getExtent().slice(0);
  } else {
    return ol_extent_createEmpty();
  }
  features.forEach((feature) => (ol_extent_extend(extent, feature.getExtent())));

  return extent;
}

function getCenter(features, options = {}) {
  let center = ol_extent_getCenter(getExtent(features));
  if (options && options.stick) {
    center = getCenterStick(features, center);
  }
  return center;
}

function getCenterStick(features, center) {
  if (features instanceof ol_geometry) {
    return features.getClosestPoint(center);
  } else if (features instanceof ol_feature) {
    return getCenterStick(features.getGeometry(), center);
  } else if (features instanceof  ol_collection) {
    return getCenterStick(features.getArray(), center);
  } if (isArray(features) && features.length > 0) {
    if (features[0] instanceof ol_geometry) {
      return getCenterStick(features.map((g) => g.getClosestPoint(center)), center);  
    } else if (features[0] instanceof ol_feature) {
      return getCenterStick(features.map((f) => f.getGeometry()), center);    
    } else if (isArray(features[0]) && features[0].length == 2) {
      features = features.map((point) => ({
        point,
        distance: ol_coordinate_distance(center, point)
      }));
      return minBy(features, 'distance').point;     
    }
  }
  
  //jeżeli nie trafiło nic to nie przypinaj
  return center;
}

function toGeometryType(type) {
  type = type.toLowerCase();

  //usunięcie typów M i Z
  if (type.endsWith('zm')) {
    type = type.substring(0, type.length - 2);
  } else if (type.endsWith('z')) {
    type = type.substring(0, type.length - 1);
  } else if (type.endsWith('m')) {
    type = type.substring(0, type.length - 1);
  }
  type = type.replace('^multi', ''); //typ multi to podstawowego

  switch (type) {
    case "point":
      return 'point';
    case "line":
    case "polyline":
    case "linestring":
      return 'line';
    case "polygon":
      return 'polygon';
    case "patch":
    case "geometrycollection":
      return 'none'; //kolekcja
    default:
      return type;
  }
}

function geometriyToSimple(features) {
  each(features, feature => {
    let geom = feature.getGeometry();
    if(!geom) {
      return;
    } else if(geom.getType() === "MultiPoint") {
      geom = geom.getPoint(0);
    } else if(geom.getType() === "MultiLineString") {
      geom = geom.getLineString(0);
    } else if(geom.getType() === "MultiPolygon") {
      geom = geom.getPolygon(0);
    }
    feature.setGeometry(geom);
  });
  return features;
}

export default {
  getExtent,
  getCenter,
  toGeometryType,
  geometriyToSimple
};



// WEBPACK FOOTER //
// ./src/utils/geometry.js